import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { getLatestChecklistSessionByCar } from '../../../api/checklistsApi';
import { useEsteiras } from '../../../hooks/useEsteiras';
import './StatusRecepcaoModal.css';

interface StatusModalProps {
  isOpen: boolean;
  carId?: string | null;
  selectedStatus: string | null;
  setSelectedStatus: (status: string | null) => void;
  onConfirm: () => void;
  onCancel: () => void;
  sidebarRef?: React.RefObject<HTMLDivElement>;
  isSidebarOpen: boolean;
}

const StatusModal: React.FC<StatusModalProps> = ({
  isOpen,
  carId,
  selectedStatus,
  setSelectedStatus,
  onConfirm,
  onCancel,
  sidebarRef,
}) => {
  const { esteirasAtivas } = useEsteiras();
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const clickedNode = event.target as Node;
      const isOutsideModal = modalRef.current && !modalRef.current.contains(clickedNode);
      const isOutsideSidebar = sidebarRef?.current && !sidebarRef.current.contains(clickedNode);

      if (isOutsideModal && isOutsideSidebar) {
        onCancel();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onCancel, sidebarRef]);

  if (!isOpen) return null;

  const handleConfirm = async (e: React.FormEvent) => {
    e.preventDefault();

    const targetEsteira = esteirasAtivas.find((e) => e.id === selectedStatus);
    if (targetEsteira?.chave === 'ENTREGA' && carId) {
      try {
        await getLatestChecklistSessionByCar(carId, { type: 'SAIDA' });
      } catch {
        toast.error('Checklist de saída ainda não foi realizado para este veículo.');
        return;
      }
    }

    onConfirm();
  };

  return (
    <div className="status-modal-overlay">
      <div className="status-modal-content" ref={modalRef}>
        <div className="LightboxStatus">
          <form className="LightboxStatusForm">
            <div className="EditarCarro">Solicitar alteração de esteira</div>
            <div className="CampoStatus">
              <div className="DropDownFormulRioStatus">
                <div className="InputSelect">
                  <select
                    className="Input"
                    name="carClass"
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    value={selectedStatus || ""}
                  >
                    <option value="" disabled>
                      Selecione uma nova esteira
                    </option>
                    {esteirasAtivas.map((est) => (
                      <option key={est.id} value={est.id}>
                        {est.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="Frame1000003998Status">
              <div className="CtaBigEditar cancel" onClick={onCancel}>
                <button className="CustomFileCancel" type="button">
                  Cancelar
                </button>
              </div>
              <button
                onClick={handleConfirm}
                className="CtaBigEditar save"
                type="button"
              >
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StatusModal;

